module.exports = __webpack_public_path__ + "static/img/8.b8a5536.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/8.png
// module id = gp2M
// module chunks = 0